// John Eldhose 20200729
import React, { Component } from 'react';
import { Button, Grid, Toolbar, Typography } from '@material-ui/core';
import { Attachment, Check, List, RateReview, Star } from '@material-ui/icons';
import { stream } from '../../lib/lib';
import RatingShow from './RatingShow';

class Curriculum extends Component {

  hb = (but) => this.props.handleButton(but);
  navButtons = [this.props.defaultButton, 'resources', 'discussion', 'rating'];
  navButDef = (but, details) => {
    if(
      but === this.props.defaultButton ||
      (typeof details[but] === 'object' && details[but].length > 0) ||
      (typeof details[but] === 'boolean' && details[but])
    ) {
      switch(but) {
        case 'courses':
          return (
            <Button key={but} color='inherit' onClick={() => this.hb(but)}>
              <List />&nbsp; Courses
            </Button>
          );
        case 'discussion':
          return (
            <Button key={but} color='inherit' onClick={() => this.hb(but)}>
              <RateReview style={{ transform: 'scale(.7)' }} />&nbsp; Discussion
            </Button>
          );
        case 'modules':
          return (
            <Button key={but} color='inherit' onClick={() => this.hb(but)}>
              <List />&nbsp; Modules
            </Button>
          );
        case 'rating':
          return (
            <Button key={but} color='inherit' onClick={() => this.hb(but)}>
              <Star style={{ transform: 'scale(.8)' }} />&nbsp; Rating
            </Button>
          );
        case 'resources':
          return (
            <Button key={but} color='inherit' onClick={() => this.hb(but)}>
              <Attachment />&nbsp; Additional Resources
            </Button>
          );
        default:
      }
    }
    else
      return '';
  }

  render() {
    var curr = (typeof this.props.curriculum[0] === 'undefined') ? [] : this.props.curriculum[0];
    return (
      <div>
        <div
          style={{
            color: '#fff',
            backgroundColor: this.props.backgroundColor,
            padding: '50px 10px 0px 10px'
          }}
        >
          <Grid container align='left' spacing={24}>
            <Grid item xs={12} sm={12} md={4}>
              <img
                alt='Course Icon'
                style={{ width: '100%', borderRadius: '3%' }}
                src={stream('academy/images/' + curr.details.icon)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <Typography variant='headline' color='inherit'>
                {curr.title}
                {(this.props.completed ?
                  <Check style={{ color: 'green', paddingLeft: '17px' }} /> :
                  <div />
                )}
              </Typography>
              <RatingShow
                ratingcount={curr.ratingcount}
                ratingsum={curr.ratingsum}
              />
              <p />
              <Typography align='justify'>
                <font color='#fff'>
                {curr.description}
                </font>
              </Typography>
            </Grid>
          </Grid>
          <Toolbar>
            {this.navButtons.map((but) => this.navButDef(but, curr.details))}
          </Toolbar>
        </div>
        <p />
        <div style={{ padding: '10px', margin: '0 20px' }}>
          {this.props.content(curr)}
        </div>
      </div>
    );
  }
}

export default Curriculum;



// WEBPACK FOOTER //
// ./src/components/home/academy/Curriculum.js